import { useI18n } from "@/i18n/I18nProvider";
import { LogoIcon } from "@/components/Logo";
import { Crown } from "lucide-react";

export default function Marquee() {
  const { t } = useI18n();
  const items = t.marquee;
  const loop = [...items, ...items, ...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#1f1f29] bg-gradient-to-r from-[#0a0a0f] via-[#11111a] to-[#0a0a0f] py-7 overflow-hidden relative"
    >
      <div className="kh-marquee gap-10 px-6">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-2xl sm:text-3xl tracking-[0.15em] uppercase text-white whitespace-nowrap">
              {item}
            </span>
            <LogoIcon size={24} color="#D4AF37" accent="#A93043" />
            <span className="font-serif-luxury italic text-xl text-[#B5651D] shrink-0">×</span>
            <LogoIcon size={24} color="#D4AF37" accent="#A93043" />
          </div>
        ))}
      </div>
    </section>
  );
}
